
export function hexColorFromString(string){
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = (hash & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

    return color.padEnd(6, '0').padStart(7, '#');
    // return "#000000".substring(1, 6 - color.length) + color;
}


export function statusStr(status) {
    switch(status){
        case "DRAFT":
            return "Brouillon";
        case "HASDRAFT":
            return "Brouillon non publié";
        case "PUBLISHED":
            return "Publié";
        case "COMPLETED":
            return "En production";
        case "ARCHIVED":
            return "Archivé";
        case "NEWPROJECT":
            return "Nouveau projet";
        case "TOPLAN":
            return "À planifier";
    }
}

export function removeNULL(obj) {
    Object.keys(obj).forEach(function (key) {
        (obj[key] && typeof obj[key] === 'object') && removeNULL(obj[key]) ||
            (obj[key] === null) && delete obj[key]
    });
    return obj;
}
export function remove__typename(obj) {
    Object.keys(obj).forEach(function (key) {
        (obj[key] && typeof obj[key] === 'object') && remove__typename(obj[key]) ||
            (key === '__typename') && delete obj[key]
    });
    return obj;
}

export function keepID(obj, filterKey) {
    if (Array.isArray(obj)) {
        obj.forEach(function (item, index) {
            obj[index] = keepID(item, filterKey);
        }.bind(filterKey))
    } else {
        Object.keys(obj).forEach(function (key) {
            if (key == filterKey) {
                if (Array.isArray(obj[key])) {
                    obj[key].forEach(function (item, itemIndex) {
                        Object.keys(item).forEach(function (prop) {
                            if (prop != 'id') {
                                delete obj[key][itemIndex][prop];
                            }
                        }.bind(filterKey))
                    })
                }else if (obj[key]) {
                    Object.keys(obj[key]).forEach(function (prop) {
                        if (prop != 'id') {
                            delete obj[key][prop];
                        }
                    }.bind(filterKey))
                }
            } else if (Array.isArray(obj[key])) {
                obj[key].forEach(function (item, index) {
                    obj[key][index] = keepID(item, filterKey);
                }.bind(filterKey))
            }
        }.bind(filterKey));
    }
    return obj;
}

export function roleName(obj) {
    
    switch (obj) {
        case "ADMINISTRATOR":
            return "Administrateur";
        case "MANAGER":
            return "Chargé de projet";
        case "STAFF":
            return "Utilisateur";
        case "FOREMAN":
            return "Contremaître";
        case "PARTNER":
            return "Partenaire";
        
        default:
            return obj;
    }

}
export function flattenRatingPivots(obj) {
    if (Array.isArray(obj)) {
        obj.forEach(function (item, index) {
            obj[index] = flattenRatingPivots(item);
        })
    } else {
        Object.keys(obj).forEach(function (key) {
            if (Array.isArray(obj[key])) {
                obj[key].forEach(function (item, index) {
                    obj[key][index] = flattenRatingPivots(item);
                })
            } else {
                if (key == "pivot") {
                    delete obj.__typename;
                    Object.keys(obj[key]).forEach(function (prop) {
                        if (prop == 'rating') {
                            obj[prop] = obj[key][prop];
                            delete obj[key];
                        }
                    })
                }
            }
        });
    }
    return obj;
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
import transform from "lodash/transform";
import isObject from "lodash/isObject";
import isEqual from "lodash/isEqual";

export function difference(object, base) {
    function changes(object, base) {
        return transform(object, function (result, value, key) {
            if (!isEqual(value, base[key])) {
                result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
            }
        });
    }
    return changes(object, base);
}

export function nl2brFunction(str) {
    if (!str) return '';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}

export function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function checkRouterRules(routeName, router) {
    let check = false;
    let routeRules = router.resolve({ name: routeName }).route.meta.rules

    if (routeRules) {
        routeRules.forEach( function (rule) {
            if ( router.options.rules[rule].check() === true) check=true;
        })
    }

    return check;
}

export function emojiReplacementList() {
    return [
        {
            src: ':)',
            dst: '0x1F600'
        },
        {
            src: ';)',
            dst: '0x1F609'
        },
        {
            src: ':(',
            dst: '0x1F641'
        },
    ]
}
